module.exports = __webpack_public_path__ + "static/media/webapp.7b568d80.svg";